import { config } from 'api';
import { UNKNOWN_ERROR } from 'utils/errors';
import { noop } from 'utils/func';
import errorHandler from 'lib/utils/errorHandler';

const DISCOUNT_CLUB_URL = `${config.apiBasePath}/customer/membership/discount-club`;

export const CHANGE_USER_VIEW_PREFERENCE = 'CHANGE_USER_VIEW_PREFERENCE';
export const REQUEST_USER_DATA = 'REQUEST_USER_DATA';
export const RECEIVE_USER_DATA = 'RECEIVE_USER_DATA';
export const FINISH_USER_DATA_FETCHING = 'FINISH_USER_DATA_FETCHING';
export const RECEIVE_USER_DATA_ERROR = 'RECEIVE_USER_DATA_ERROR';
export const SET_NO_ROUTE_ACCESS = 'SET_NO_ROUTE_ACCESS';
export const DISCOUNT_CLUB_DATA = 'DISCOUNT_CLUB_DATA';
export const SET_NICKNAME = 'SET_NICKNAME';

export function setNoRouteAccess(action) {
  return {
    type: SET_NO_ROUTE_ACCESS,
    action,
  };
}

export function requestUserData() {
  return {
    type: REQUEST_USER_DATA,
  };
}

export function receiveUserData(user) {
  return {
    type: RECEIVE_USER_DATA,
    user,
  };
}

export function finishUserDataFetching() {
  return {
    type: FINISH_USER_DATA_FETCHING,
  };
}

export function receiveUserDataError(json) {
  return {
    type: RECEIVE_USER_DATA_ERROR,
    error: json.error,
  };
}

export function setNickname(customerNickname) {
  return {
    type: SET_NICKNAME,
    customerNickname,
  };
}

// not a redux action, do not dispatch it directly, use fetchUserData
export function getUserData(dispatch, network, onUserDataFetched = noop) {
  dispatch(requestUserData());
  return network.get(`${config.apiBasePath}/user-profile`, {
    proxyQueryParams: ['ssoToken', 'customerNum'],
  })
    .then((userData) => {
      dispatch(receiveUserData(userData));
      onUserDataFetched();
      dispatch(finishUserDataFetching());
      return userData;
    })
    .catch(err => {
      dispatch(receiveUserDataError(err.data || UNKNOWN_ERROR));
    });
}

export function fetchUserData(onUserDataFetched) {
  return (dispatch, getState, { network }) => getUserData(dispatch, network, onUserDataFetched);
}

export function changeUserViewPreference(value) {
  return {
    type: CHANGE_USER_VIEW_PREFERENCE,
    value,
  };
}

export function receiveDiscountClub(data) {
  return {
    type: DISCOUNT_CLUB_DATA,
    data,
  };
}

export function getDiscountClub() {
  return (dispatch, getState, { network }) => network.get(DISCOUNT_CLUB_URL)
    .then(data => dispatch(receiveDiscountClub(data)))
    .catch(err => errorHandler(err));
}

